import { useState } from 'react'

import HorizontalBarChart, { HChartSeries } from '@/components/ui/charts/horizontal-bar-chart/HorizontalBarChart'
import Drilldown from '@/insights/components/Drilldown'
import { InsightConfigurationType } from '@/types/dashboard-types'

import type { StationaryAssetCountData, StationaryAssetCountParams } from './StationaryAssetCount'

const HorizontalChart = ({
  configuration,
  data,
}: {
  configuration: InsightConfigurationType
  data: StationaryAssetCountData[]
}) => {
  const [activeDrilldown, setActiveDrilldown] = useState<InsightConfigurationType | null>(null)

  const isSmallCard = ['tiny', 'mini'].includes(configuration.width)

  const sortedData = [...data].sort((a, b) => a.assetCount - b.assetCount)
  const yAxisData = sortedData.map((item) => item.companyName)

  const formatLabel = (params: { value: number }): string => {
    const val = params.value
    if (val < 1000) return ''
    if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M'
    if (val >= 1000) return (val / 1000).toFixed(1) + 'K'
    return val.toString()
  }

  const series: HChartSeries[] = [
    {
      name: 'Asset Count',
      data: sortedData.map((item) => item.assetCount),
      color: '#6AC380',

      label: {
        show: !isSmallCard,
        position: 'insideLeft',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        formatter: formatLabel as any,
        color: '#000',
      },
    },
  ]

  const handleBarClick = (params: { seriesName: string; name: string }) => {
    const parameters = configuration.parameters as StationaryAssetCountParams
    const clickedCompany = data.find((item) => item.companyName === params.name)

    const ddConfig: InsightConfigurationType = {
      ...configuration,
      slug: 'utilization/stationary-assets-detail',
      title: `${configuration.title}: Details - ${params.name}`,
      parameters: {
        ...parameters,
        companyId: clickedCompany?.companyId,
        companyIds: undefined,
        displayFormat: 'table',
        isDrilldown: true,
      },
    }

    setActiveDrilldown(ddConfig)
  }

  return (
    <>
      {activeDrilldown && <Drilldown configuration={activeDrilldown} onClose={() => setActiveDrilldown(null)} />}
      <HorizontalBarChart yAxisData={yAxisData} series={series} onBarClick={handleBarClick} />
    </>
  )
}

export default HorizontalChart
